import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';

export type LegacyContentExtensionHandlerProps =
	import('./LegacyContentExtensionHandler.tsx').LegacyContentExtensionHandlerProps;

export const LegacyContentExtensionHandlerPaint: LoadableType<LegacyContentExtensionHandlerProps> =
	LoadablePaint({
		loader: async () =>
			(
				await import(
					/* webpackChunkName: "loadable-LegacyContentExtensionHandler" */ './LegacyContentExtensionHandler.tsx'
				)
			).LegacyContentExtensionHandler,
	});
